import { createAction } from '@saucelabs/sl-util-redux';

import * as constants from './types';

export const startTypingTestName = createAction(constants.START_TYPING_TEST_NAME);
export const allTestsLoaded = createAction(constants.ALL_TESTS_LOADED);
